import type { JSX } from 'react';
import { SeriesDetailLayout, type SeriesDetailLayoutProps } from './SeriesDetailLayout';

export type SeriesDetailVariant = 'standard' | 'episode-grid' | 'reading-list';

export function resolveSeriesDetailVariant(
  _variant: SeriesDetailVariant | undefined,
): (props: SeriesDetailLayoutProps) => JSX.Element | null {
  return SeriesDetailLayout;
}
